import React from 'react';
import { Handle, Position, NodeProps } from 'reactflow';
import StartNode from './StartNode';
import QuestionNode from './QuestionNode';
import ResultNode from './ResultNode';
import JumpNode from './JumpNode';

// 导出所有节点类型组件
export default {
    StartNode,
    QuestionNode,
    ResultNode,
    JumpNode,
};
